import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';

export const LatitudePayIcon = createIcon({
  path: (
    <>
      <g clipPath="url(#latitude-pay-icon)">
        <path
          d="M141.7 90.3c0 6.8-5.6 12.4-12.4 12.4-6.8 0-12.4-5.6-12.4-12.4 0-6.8 5.6-12.4 12.4-12.4 6.8 0 12.4 5.6 12.4 12.4zM129.3 0c-6.8 0-12.4 5.6-12.4 12.4s5.6 12.4 12.4 12.4c6.8 0 12.4-5.6 12.4-12.4 0-6.9-5.6-12.4-12.4-12.4zm0 38.9c-6.8 0-12.4 5.6-12.4 12.4 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.8-5.6-12.4-12.4-12.4zM24.8 0H0v141.7h141.7v-24.8H24.8V0zm65.5 24.8c6.8 0 12.4-5.6 12.4-12.4S97.1 0 90.3 0 77.9 5.6 77.9 12.4s5.6 12.4 12.4 12.4zm-39 0c6.8 0 12.4-5.6 12.4-12.4S58.1 0 51.3 0 38.9 5.6 38.9 12.4c0 6.8 5.6 12.4 12.4 12.4zm159.8 14.1h-12.8v63.8h46.3V89.9h-33.5v-51zm424 31.9c0 12.2-5.5 19.6-10.1 23.6-6.2 5.5-14.2 8.3-23.7 8.3h-24.7V38.9h24.7c9.5 0 17.5 2.8 23.7 8.3 4.6 4.1 10.1 11.5 10.1 23.6zm-12.7 0c0-6-1.9-10.7-5.8-14.1-3.9-3.4-8.9-5.1-15.3-5.1h-11.9v38.3h11.9c6.4 0 11.5-1.7 15.3-5.1 3.8-3.3 5.8-8 5.8-14zM699 51.7V38.9h-48.2v63.8H699V89.9h-35.4v-13h27.6V64.7h-27.6v-13H699zM296.1 38.9l28.9 63.8h-14l-5.8-12.8h-30l-5.8 12.8h-14l28.9-63.8h11.8zm3.3 38.3-9.2-20.4-9.2 20.4h18.4zM545 74.9c0 6.1-1.3 10.6-3.8 13.3-1.4 1.6-4.1 3.6-10.6 3.6s-9.2-2.1-10.6-3.6c-2.5-2.7-3.8-7.2-3.8-13.3V39h-12.8v35.9c0 9.5 2.4 16.8 7.1 22 4.8 5.2 11.4 7.7 20 7.7s15.2-2.6 20-7.7c4.8-5.2 7.1-12.5 7.1-22V39h-12.8v35.9h.2zM327.6 51.7h20.1v51h12.8v-51h20.4V38.9h-53.3v12.8zm103.7 0h20.1v51h12.8v-51h20.4V38.9h-53.3v12.8zm-31.6 51h12.8V38.9h-12.8v63.8z"
          fill="#0046aa"
        />
      </g>
    </>
  ),
  viewBox: '0 0 703 142',
  defaultProps: {
    height: 22,
    width: 'auto',
  },
});
